import React from 'react';
import { MenuItem, Select, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    height: '1rem',
    width: '3.0rem',
    fontSize: '0.75rem'
  },
}));

interface Props {
  value: number,
  onChange: (e: React.ChangeEvent<{
    name?: string | undefined;
    value: unknown;
  }>) => void,
}

/** タクシーの台数選択のコンポーネント。 */
export const SelectCarNum: React.FC<Props> = (props: Props) => {
  const classes = useStyles();
  /** タクシーの台数の値（1~20までの数値）の配列。 */
  const numbers = Array.from({length: 20}, (_, i) => i + 1);

  return (
    <Select
      className={classes.root}
      SelectDisplayProps={{
        style: {
          padding: '10px'
        }
      }}
      onChange={props.onChange}
      value={props.value}
    >
      {
        numbers.map((n) => {
          return <MenuItem value={n} key={`car_num_${n}`}>{n}</MenuItem>
        })
      }
    </Select>
  );
}

export default SelectCarNum;
